import {isNotEmpty} from "./strings";

/**
 * 郵便場合を整形
 */
export function formantZip(zip_code) {
  if(isNotEmpty(zip_code)) {
    if (!zip_code.includes("-") && zip_code.length === 7) {
      return zip_code.slice(0,3) + "-" + zip_code.slice(3);
    }
  }
  return "";
}